import { render } from "./safety-features.vue?vue&type=template&id=a14c32e2"
import script from "./safety-features.vue?vue&type=script&lang=js"
export * from "./safety-features.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__